import * as types from '../constants/ActionTypes';

function success(message) {
  return { type: types.SUCCESS, message };
}

function error(message) {
  switch (message) {
    case 'AxiosError: Request failed with status code 401': {
      return { type: types.ERROR, message: 'Username or password is incorrect' };
    }
    case 'AxiosError: Network Error': {
      return { type: types.ERROR, message: 'There is a network error with the server' };
    }
    case 'AxiosError: Request failed with status code 409': {
      return { type: types.ERROR, message: 'This email already exists. Please log in' };
    }
    default: {
      return { type: types.ERROR, message: 'Something wrong has happened. Please contact your administrator.'};
    }
  }
}

function clear() {
  return { type: types.CLEAR };
}

export const alertActions = {
  success,
  error,
  clear,
};
